import {
	AnalyticsStep,
	InsertTypeAheadStep,
	LinkMetaStep,
	SetAttrsStep,
} from '@atlaskit/adf-schema/steps';
import {
	AddMarkStep,
	AddNodeMarkStep,
	AttrStep,
	DocAttrStep,
	RemoveMarkStep,
	RemoveNodeMarkStep,
	type Step,
} from '@atlaskit/editor-prosemirror/transform';

// This function is used to determine if the doc content changed by a step.
// Changes like bold or text color are not considered as doc content change.
// steps from sanitizeFilteredStep in platform/packages/editor/editor-plugin-collab-edit/src/pm-plugins/track-and-filter-spamming-steps.ts
export function noContentChangedInStep(step: Step): boolean {
	return (
		// bold will trigger AddMarkStep and RemoveMarkStep
		step instanceof AddMarkStep ||
		step instanceof RemoveMarkStep ||
		// add mark to node
		step instanceof AddNodeMarkStep ||
		step instanceof RemoveNodeMarkStep ||
		// update node attribute
		step instanceof AttrStep ||
		// update doc attribute
		step instanceof DocAttrStep ||
		// tick action item will trigger SetAttrsStep
		step instanceof SetAttrsStep ||
		// change link text will trigger LinkMetaStep
		step instanceof LinkMetaStep ||
		// type / typeahead will trigger InsertTypeAheadStep
		step instanceof InsertTypeAheadStep ||
		step instanceof AnalyticsStep
	);
}
